import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: anatomy['size-12'],
  },
  title: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
    fontFamily: fonts.din2014Demi,
    color: colors.primaryText,
  },
  actions: {
    display: 'flex',
    gap: anatomy['size-8'],
    ':not(#__unused__) button': {
      padding: '8px 20px',
      fontSize: typography['fontSizeCaption-1'],
      lineHeight: typography['lineHeightCaption-1'],
    },
  },
});
